export default "__VITE_ASSET__e5b0d5ed__"